export default "__VITE_ASSET__DfCXh3Xl__"